import React, { useState, useEffect,useRef,useCallback,useMemo } from "react";
import moment from 'moment'
import axios from '../../plugins/axios';
import { useTranslation } from "react-i18next";
import { mmHgToKPa, celsiusToFahrenheit, percentTommHg, percentToKpa, mmHgToPercent } from '../../plugins/common'
import { useRecoilState } from 'recoil';
import { selectBedInfoState,unitState,isFromSearchState } from '../../plugins/recoil';

import {ReactComponent as IconArrowUp} from '../../assets/icons/ic-arrow-up.svg'
import {ReactComponent as IconArrowDown} from '../../assets/icons/ic-arrow-down.svg'
import {ReactComponent as IconCheck} from '../../assets/icons/ic-check-blue.svg'

import GraphComponent from './GraphicTrend/GraphComponent'

const GraphicTrend = ({ isTrendFull, onClose, selectBoxTimeInfo, handleSelectBoxTimeInfo, waveStartDate, waveEndDate, trendZoom, patientHistories }) => {
    const { t } = useTranslation()
    const graphicTrendContainerRef = useRef(null)
    const dropdownRefs = useRef([]);
    const [selectBedInfo, ] = useRecoilState(selectBedInfoState)    
    const [isFromSearch, ] = useRecoilState(isFromSearchState)
    const [units,] = useRecoilState(unitState);
    const [numericData, setNumericData] = useState([])    
    const [chartWidth, setChartWidth] = useState(0)
    const [chartHeight, setChartHeight] = useState(0)
    const [timeRanges, setTimeRanges] = useState([])
    const [numericCodeList, setNumericCodeList] = useState([])
    const [numericParameters, setNumericParameters] = useState([])
    const [stripedBackground, setStripedBackground] = useState(); // 빗금 배경
    const [patientLines, setPatientLines] = useState(); // 빗금 위치 상태 추가
    const [scrollLeft, setScrollLeft] = useState(0);

    const [dropdownStates, setDropdownStates] = useState({
        numeric1: false,
        numeric2: false,
        numeric3: false,
    });

    const [numericDatas, setNumericDatas] = useState({
        numeric1: [],
        numeric2: [],
        numeric3: [],
    })

    const [numericPoints, setNumericPoints] = useState({
        numeric1: [],
        numeric2: [],
        numeric3: [],
    })

    //Key 값이 달라서 세팅
    const UnitType = {
        "hr" : "HR",
        "arrhythmia" : "arrhythmia",
        "spo2Percent" : "SpO2",
        "rrRpm" : "RR",
        "temp1C" : "Temp1",
        "temp2C" : "Temp2",
        "awrrRpm" : "awRR",
        "ibp1" : "IBP1",
        "ibp2" : "IBP2",
        "ibp3" : "IBP3",
        "ibp4" : "IBP4",
        "nibp" : "NIBP",
        // "gasCo2" : "GAS",
        // "gasDes" : "GAS",
        // "gasN2o" : "GAS",
        // "gasO2" : "GAS",
        // "gasSev" : "GAS",
        "etCo2" : "EtCO2",
        "inCo2" : "InCO2",
        "ipi" : "IPI",
    }

    // ✅ CodeList 가져오기 
    const getCodeList = () => {
        const codeList = [
            { label: `HR${units['HR'] ? ` (${units['HR']})` : ``}`, value: 'hr' },
            { label: `Arrhythmia${units['arrhythmia'] ? ` (${units['arrhythmia']})` : ``}`, value: 'arrhythmia' },
            { label: `SpO2${units['SpO2'] ? ` (${units['SpO2']})` : ``}`, value: 'spo2Percent' },
            { label: `RR${units['RR'] ? ` (${units['RR']})` : ``}`, value: 'rrRpm' },
            { label: `Temp1${units['Temp1'] ? ` (${units['Temp1']})` : ``}`, value: 'temp1C' },
            { label: `Temp2${units['Temp2'] ? ` (${units['Temp2']})` : ``}`, value: 'temp2C' },
            { label: `awRR${units['awRR'] ? ` (${units['awRR']})` : ``}`, value: 'awrrRpm' },
            { label: `IBP1${units['IBP1'] ? ` (${units['IBP1']})` : ``}`, value: 'ibp1' },
            { label: `IBP2${units['IBP2'] ? ` (${units['IBP2']})` : ``}`, value: 'ibp2' },
            { label: `IBP3${units['IBP3'] ? ` (${units['IBP3']})` : ``}`, value: 'ibp3' },
            { label: `IBP4${units['IBP4'] ? ` (${units['IBP4']})` : ``}`, value: 'ibp4' },
            { label: `NIBP${units['NIBP'] ? ` (${units['NIBP']})` : ``}`, value: 'nibp' },
            { label: `EtCO2${units['EtCO2'] ? ` (${units['EtCO2']})` : ``}`, value: 'etCo2' },
            { label: `InCO2${units['InCO2'] ? ` (${units['InCO2']})` : ``}`, value: 'inCo2' },
            { label: `IPI`, value: 'ipi' },
            // { label: `GAS CO2${units['GAS'] ? ` (${units['GAS']})` : ``}`, value: 'gasCo2' }, 
            // { label: `GAS O2${units['GAS'] ? ` (${units['GAS']})` : ``}`, value: 'gasO2' },
            // { label: `GAS DES${units['GAS'] ? ` (${units['GAS']})` : ``}`, value: 'gasDes' },
            // { label: `GAS SEV${units['GAS'] ? ` (${units['GAS']})` : ``}`, value: 'gasSev' },
            // { label: `GAS N2O${units['GAS'] ? ` (${units['GAS']})` : ``}`, value: 'gasN2o' },
        ];                

        setNumericCodeList(codeList);

        const hr = codeList.find(item => item.value === 'hr');
        const arrhythmia = codeList.find(item => item.value === 'arrhythmia');
        const spO2 = codeList.find(item => item.value === 'spo2Percent');
        if (isTrendFull) {
            setNumericParameters([
                { value: hr.value, label: hr.label },
                { value: arrhythmia.value, label: arrhythmia.label },
                { value: spO2.value, label: spO2.label },
            ])
        } else {
            setNumericParameters([
                { value: hr.value, label: hr.label },
            ])
        }
    }
    
    //빗금 만들기 위함
    const getPatientHistories = (histories) => {
        if (!histories || !Array.isArray(histories) || histories.length === 0) {
            setStripedBackground([]);
            setPatientLines([]);
            return;
        }

        const startTime = moment(waveStartDate);
        const endTime = moment(waveEndDate);

        // waveStartDate ~ waveEndDate 범위에 포함되는 데이터만 필터링
        const unassignedList = histories            
            .filter(h => {
                const t = moment(h.createdAt);
                return t.isValid() && t.isSameOrAfter(startTime) && t.isSameOrBefore(endTime);
            })
            .sort((a, b) => moment(a.createdAt).valueOf() - moment(b.createdAt).valueOf());

        // selectBoxTimeInfo 시간
        const selectBoxTime = moment(selectBoxTimeInfo);
        const totalDuration = endTime.diff(startTime); // 전체 구간 ms

        // chartWidth가 0이면 처리하지 않음
        if (!chartWidth || chartWidth === 0) {
            setStripedBackground([]);
            setPatientLines([]);
            return;
        }

        // 환자별로 그룹화
        const patientGroups = {};
        unassignedList.forEach(history => {
            if (!patientGroups[history.patientId]) {
                patientGroups[history.patientId] = [];
            }
            patientGroups[history.patientId].push(history);
        });

        // 빗금 영역과 선 위치 배열        
        const linePositions = [];

        // Not Admitted 구간 정의
        const notAdmittedSegments = [];

        // 환자가 없는 경우 전체 구간을 Not Admitted로 설정
        if (Object.keys(patientGroups).length === 0) {
            notAdmittedSegments.push({
                start: startTime.clone(),
                end: endTime.clone(),
                shouldDrawLine: false,
                type: 'NO_PATIENT_DATA'
            });
        }

        // 각 환자별로 Not Admitted 구간 찾기
        Object.keys(patientGroups).forEach(patientId => {
            const patientHistories = patientGroups[patientId].sort((a, b) => 
                moment(a.createdAt).valueOf() - moment(b.createdAt).valueOf()
            );

            // 각 환자별로 순차적으로 구간 생성 (중복 방지)
            let currentTime = startTime.clone();

            for (let i = 0; i < patientHistories.length; i++) {
                const current = patientHistories[i];
                const currentEventTime = moment(current.createdAt);

                // 현재 시간부터 현재 이벤트까지의 구간 (Not Admitted)
                if (currentTime.isBefore(currentEventTime)) {
                    notAdmittedSegments.push({
                        start: currentTime.clone(),
                        end: currentEventTime,
                        shouldDrawLine: true,
                        type: `${currentTime.isSame(startTime) ? 'START' : 'CONTINUING'}_TO_${current.action}`,
                        patientId: patientId
                    });
                }

                // 현재 이벤트 처리
                if (current.action === 'ADMITTED') {
                    // ADMITTED 이후 다음 이벤트까지 또는 endTime까지 (Not Admitted)
                    const next = patientHistories[i + 1];
                    const nextEventTime = next ? moment(next.createdAt) : endTime.clone();

                    notAdmittedSegments.push({
                        start: currentEventTime,
                        end: nextEventTime,
                        shouldDrawLine: next ? true : false, // 다음 이벤트가 있으면 선 표시, endTime까지면 선 없음
                        type: next ? `ADMITTED_TO_${next.action}` : 'ADMITTED_TO_END',
                        patientId: patientId
                    });

                    currentTime = nextEventTime;
                } else if (current.action === 'UNASSIGNED') {
                    // UNASSIGNED 이후 전체 히스토리에서 다음 ADMITTED 찾기
                    let nextAdmitted = null;
                    let nextAdmittedTime = null;
                    
                    // 전체 환자 히스토리에서 현재 UNASSIGNED 이후의 ADMITTED 찾기
                    const currentUnassignedTime = moment(current.createdAt);
                    
                    // 모든 환자의 히스토리를 시간순으로 정렬하여 검색
                    const allHistoriesAfterUnassigned = [];
                    Object.keys(patientGroups).forEach(pid => {
                        patientGroups[pid].forEach(history => {
                            const historyTime = moment(history.createdAt);
                            if (historyTime.isAfter(currentUnassignedTime)) {
                                allHistoriesAfterUnassigned.push(history);
                            }
                        });
                    });
                    
                    // 시간순으로 정렬
                    allHistoriesAfterUnassigned.sort((a, b) => 
                        moment(a.createdAt).valueOf() - moment(b.createdAt).valueOf()
                    );
                    
                    // 첫 번째 ADMITTED 찾기
                    for (let history of allHistoriesAfterUnassigned) {
                        if (history.action === 'ADMITTED') {
                            nextAdmitted = history;
                            nextAdmittedTime = moment(history.createdAt);
                            break;
                        }
                    }
                    
                    const nextEventTime = nextAdmittedTime || endTime.clone();

                    notAdmittedSegments.push({
                        start: currentEventTime,
                        end: nextEventTime,
                        shouldDrawLine: nextAdmitted ? true : false, // 다음 ADMITTED가 있으면 선 표시
                        type: nextAdmitted ? `UNASSIGNED_TO_ADMITTED` : 'UNASSIGNED_TO_END',
                        patientId: patientId
                    });

                    // currentTime을 다음 ADMITTED 시점으로 이동
                    currentTime = nextEventTime;
                    
                    // 다음 ADMITTED를 찾았으면 해당 시점 이후로 건너뛰기
                    if (nextAdmitted) {
                        // 현재 환자의 히스토리에서 다음 ADMITTED 시점 이후의 이벤트부터 계속 처리
                        while (i + 1 < patientHistories.length && 
                                moment(patientHistories[i + 1].createdAt).isSameOrBefore(nextAdmittedTime)) {
                            i++;
                        }
                    } else {
                        // ADMITTED가 없으면 루프 종료
                        break;
                    }
                }
            }

            // 마지막 이벤트 이후 endTime까지 구간이 남아있다면 추가
            if (currentTime.isBefore(endTime)) {
                notAdmittedSegments.push({
                    start: currentTime.clone(),
                    end: endTime.clone(),
                    shouldDrawLine: true,
                    type: 'FINAL_TO_END',
                    patientId: patientId
                });
            }
        });

        // 각 Not Admitted 구간을 독립적으로 처리 (픽셀 단위로 계산)
        const allNotAdmittedRanges = []; // 모든 Not Admitted 범위를 저장
        
        notAdmittedSegments.forEach((segment, segmentIndex) => {
            // startTime과 endTime 범위 내의 구간만 처리
            const segmentStart = moment.max(segment.start, startTime);
            const segmentEnd = moment.min(segment.end, endTime);
            
            // 유효한 구간인지 확인
            if (segmentEnd.isAfter(segmentStart)) {
                // 픽셀 단위로 계산
                const startPx = (segmentStart.diff(startTime) / totalDuration) * chartWidth;
                const endPx = (segmentEnd.diff(startTime) / totalDuration) * chartWidth;
                
                // unix를 사용한 정확한 시간 비교
                const selectBoxTimeUnix = selectBoxTime.unix();
                const segmentStartUnix = segmentStart.unix();
                const segmentEndUnix = segmentEnd.unix();
                
                const isSelectBoxInSegment = selectBoxTimeUnix >= segmentStartUnix && selectBoxTimeUnix <= segmentEndUnix;

                // console.log(`구간 ${segmentIndex + 1} (${segment.type}):`, {
                //     환자ID: segment.patientId,
                //     구간: `${segmentStart.format('HH:mm:ss')} ~ ${segmentEnd.format('HH:mm:ss')}`,
                //     selectBox위치: selectBoxTime.format('HH:mm:ss'),
                //     selectBox구간포함: isSelectBoxInSegment,
                //     빗금표시예정: !isSelectBoxInSegment,
                //     선표시예정: segment.shouldDrawLine && !isSelectBoxInSegment,
                //     픽셀위치: `${startPx.toFixed(1)}px ~ ${endPx.toFixed(1)}px`
                // });
                
                // selectBoxTime이 구간에 포함되지 않으면 Not Admitted 범위에 추가
                if (!isSelectBoxInSegment) {
                    allNotAdmittedRanges.push({
                        start: Math.max(0, startPx),
                        end: Math.min(chartWidth, endPx)
                    });
                }

                // 선 추가 (selectBox와 관계없이 독립적으로) - 픽셀 단위
                if (!isSelectBoxInSegment && segment.shouldDrawLine && endPx >= 0 && endPx <= chartWidth) {
                    if(startPx > 0){
                        linePositions.push(startPx);
                    }
                    if(endPx < chartWidth){
                        linePositions.push(endPx);
                    }                    
                }
            }
        });

        // // Not Admitted 범위들을 병합하여 중복 제거 (픽셀 단위)
        // const mergedStripedAreas = mergeOverlappingRanges(allNotAdmittedRanges);

        // // 중복 제거 및 정렬
        // const uniqueLinePositions = [...new Set(linePositions)].sort((a, b) => a - b);

        // console.log('병합 전 Not Admitted 범위들 (px):', allNotAdmittedRanges);
        // console.log('병합 후 빗금 영역 (px):', mergedStripedAreas);
        // console.log('최종 선 위치 (px):', uniqueLinePositions);

        // // 빗금 영역과 선 설정
        // setStripedBackground(mergedStripedAreas);
        // setPatientLines(uniqueLinePositions);

        // Not Admitted 범위들을 병합하여 중복 제거 (픽셀 단위)
        const mergedStripedAreas = mergeOverlappingRanges(allNotAdmittedRanges);

        // padding 값 정의 (양쪽 50px)
        const padding = 50;

        // 빗금 영역 start, end에 padding 적용
        const adjustedStripedAreas = mergedStripedAreas.map(area => ({
            start: area.start + padding,
            end: area.end + padding
        }));

        // 최종 선 위치에도 padding 적용
        const uniqueLinePositions = [...new Set(linePositions)].sort((a, b) => a - b);
        const adjustedLinePositions = uniqueLinePositions.map(pos => pos + padding);

        console.log('병합 전 Not Admitted 범위들 (px):', allNotAdmittedRanges);
        console.log('병합 후 빗금 영역 (px):', adjustedStripedAreas);
        console.log('최종 선 위치 (px):', adjustedLinePositions);

        // 빗금 영역과 선 설정
        setStripedBackground(adjustedStripedAreas);
        setPatientLines(adjustedLinePositions);
    };

    // 겹치는 범위들을 병합하는 함수
    const mergeOverlappingRanges = (ranges) => {
        if (ranges.length === 0) return [];
        
        // start 기준으로 정렬
        const sortedRanges = ranges.sort((a, b) => a.start - b.start);
        const merged = [sortedRanges[0]];
        
        for (let i = 1; i < sortedRanges.length; i++) {
            const current = sortedRanges[i];
            const lastMerged = merged[merged.length - 1];
            
            // 겹치거나 인접한 경우 병합
            if (current.start <= lastMerged.end) {
                lastMerged.end = Math.max(lastMerged.end, current.end);
            } else {
                // 겹치지 않는 경우 새 범위 추가
                merged.push({
                    start: current.start,
                    end: current.end
                });
            }
        }
        
        return merged;
    };

    // ✅ Numeric DropDown 상태 변경
    const handleClickOutside = (event) => {
        // 모든 드롭다운 ref를 확인
        let isClickedInside = false;
        dropdownRefs.current.forEach(ref => {
            if (ref && ref.contains(event.target)) {
                isClickedInside = true;
            }
        });
        
        if (!isClickedInside) {
            setDropdownStates({
                numeric1: false,
                numeric2: false,
                numeric3: false,
            });
        }
    };

    // ✅ handleChangeSelect 함수에 로그 추가
    const handleChangeSelect = (val, index) => {
        //console.log('handleChangeSelect 호출됨:', { val, index, currentParameter: numericParameters[index] });
        
        const updatedNumericParameters = [...numericParameters];
        updatedNumericParameters[index] = {
            ...updatedNumericParameters[index],
            value: val.value,            
            label: val.label
        };
        
        //console.log('업데이트될 파라미터:', updatedNumericParameters);
        setNumericParameters(updatedNumericParameters);
        
        // 드롭다운 닫기
        setDropdownStates(prev => ({
            ...prev,
            [`numeric${index + 1}`]: false
        }));
    }

    // ✅ Tabular Trend Data 가져오기
    const getNumericData = async () => {
        try{
            const res = await axios.get(`/trend/tabular/vitals?serialNo=${selectBedInfo?.serial}&startTime=${moment.utc(waveStartDate).format('YYYY-MM-DDTHH:mm:ss')}Z&endTime=${moment.utc(waveEndDate).format('YYYY-MM-DDTHH:mm:ss')}Z`);                                    
            const data = res.data.data;            
            const sortedData = [...data].sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));             
            const convertedData = convertTrendData(sortedData)   
            console.log('Converted Data:', convertedData);
            setNumericData(convertedData);
        }
        catch(err){
            console.warn('getNumericData error:', err);
        }
    }

    // ✅ Search시 Tabular Trend Data 가져오기
    const getIsSearchNumericData = async () => {
        try{

            const deviceHistory = selectBedInfo?.deviceHistory || [];
            const searchStart = moment(waveStartDate);
            const searchEnd = moment(waveEndDate);

            // 1. 환자별 입퇴원 기간 생성 (시리얼 기준)
            const periods = [];
            const sortedHistory = deviceHistory.slice().sort((a, b) => moment(a.createdAt) - moment(b.createdAt));
            let currentPeriod = null;
            sortedHistory.forEach(h => {
                if (h.action === 'ADMITTED') {
                    currentPeriod = {
                        serial: h.serial,
                        start: moment(h.createdAt),
                        end: null
                    };
                } else if (h.action === 'UNASSIGNED' && currentPeriod) {
                    currentPeriod.end = moment(h.createdAt);
                    periods.push(currentPeriod);
                    currentPeriod = null;
                }
            });
            if (currentPeriod && !currentPeriod.end) {
                currentPeriod.end = moment(); // 현재까지 입원
                periods.push(currentPeriod);
            }

            // 2. 검색 구간과 겹치는 기간만 추출
            const plans = [];
            periods.forEach(period => {
                const planStart = moment.max(searchStart, period.start);
                const planEnd = moment.min(searchEnd, period.end);
                if (planEnd.isAfter(planStart)) {
                    plans.push({
                        serial: period.serial,
                        start: planStart,
                        end: planEnd
                    });
                }
            });

            let graphicTrend = [];
            for (const plan of plans) {
                const res = await axios.get(`/trend/tabular/vitals?serialNo=${plan.serial}&startTime=${plan.start.utc().format('YYYY-MM-DDTHH:mm:ss')}Z&endTime=${plan.end.utc().format('YYYY-MM-DDTHH:mm:ss')}Z`);
                if (res.code != '200') throw res;
                const data = res.data.data;
                graphicTrend = graphicTrend.concat(data);
            }

            const sortedData = [...graphicTrend].sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));
            const convertedData = convertTrendData(sortedData)
            setNumericData(convertedData);
        }
        catch(err){
            console.warn('getIsSearchNumericData error:', err);
        }
    }

    // ✅ Trend Data Unit 변경
    const convertTrendData = (data) => {
        // 배열인지 단일 객체인지 확인
        const dataArray = Array.isArray(data) ? data : [data];
        
        // 각 데이터 항목을 변환
        const convertedDataArray = dataArray.map(item => {
            // 기본 필드들은 그대로 유지
            const convertedItem = {
                timestamp: item.timestamp,
                patientId: item.patientId,
                patientName: item.patientName
            };

            // item에 실제로 있는 키들만 순회 (기본 필드 제외)
            Object.keys(item).forEach(parameterKey => {
                // 기본 필드들은 건너뛰기
                if (['timestamp', 'patientId', 'patientName'].includes(parameterKey)) {
                    return;
                }            

                const originalData = item[parameterKey];
                const nibpSeries = ['NIBP'];
                const ibpSeries = ['IBP1', 'IBP2', 'IBP3', 'IBP4'];
                const tempSeries = ['Temp1', 'Temp2'];                        
                const otherSeries = ['HR', 'RR', 'awRR', 'SpO2', 'arrhythmia', 'IPI'];
                
                const convertFunctions = {
                    mmHgToKPa,
                    celsiusToFahrenheit,
                    percentTommHg,
                    percentToKpa,
                    mmHgToPercent
                };

                let unit = undefined;
                let functionName = undefined;
                
                // UnitType을 사용해서 매핑된 파라미터명 가져오기
                const mappedParameter = UnitType[parameterKey];                

                if (nibpSeries.includes(mappedParameter)) {
                    unit = units["NIBP"];                    
                    if (unit === 'kPa') {
                        functionName = 'mmHgToKPa'; // mmHg를 kPa로 변환하는 함수
                    }
                } else if (ibpSeries.includes(mappedParameter)) {
                    const prefix = mappedParameter.match(/^IBP[1-4]/)?.[0];  // "IBP1", "IBP2" 등 추출
                    unit = units[prefix];
                    if (unit === 'kPa') {
                        functionName = 'mmHgToKPa'; // mmHg를 kPa로 변환하는 함수
                    }
                } else if (tempSeries.includes(mappedParameter)) {            
                    unit = units[mappedParameter];
                    if (unit === '°F') {
                        functionName = 'celsiusToFahrenheit'; // 섭씨를 화씨로 변환하는 함수
                    }
                }                 
                else if (otherSeries.includes(mappedParameter)) {
                    unit = units[mappedParameter];
                }

                let convertedValue = originalData.value;

                // 변환 함수가 있으면 적용
                const isBloodPressure = nibpSeries.includes(mappedParameter) || ibpSeries.includes(mappedParameter);                
                const hasConvertFunc = functionName && typeof convertFunctions[functionName] === 'function';

                if (isBloodPressure) {
                    // 혈압 데이터 처리
                    const splitValue = originalData.value.split('/');
                    const convertedSplitValues = splitValue.map(val => 
                        hasConvertFunc ? String(convertFunctions[functionName](val)) : val
                    );

                    // sys, dia, map 개별 추가
                    convertedItem[`${parameterKey}sys`] = {
                        value: convertedSplitValues[0],
                        alarm: originalData.alarm,
                        priority: originalData.priority
                    };
                    convertedItem[`${parameterKey}dia`] = {
                        value: convertedSplitValues[1],
                        alarm: originalData.alarm,
                        priority: originalData.priority
                    };
                    convertedItem[`${parameterKey}map`] = {
                        value: convertedSplitValues[2],
                        alarm: originalData.alarm,
                        priority: originalData.priority
                    };
                } else {
                    // 단일 값 처리
                    if (hasConvertFunc) {
                        convertedValue = String(convertFunctions[functionName](originalData.value));
                    }
                    convertedItem[parameterKey] = {
                        value: convertedValue,
                        alarm: originalData.alarm,
                        priority: originalData.priority
                    };
                }
            });

            return convertedItem;
        });

        // 원래 입력이 배열이었으면 배열로, 단일 객체였으면 첫 번째 요소만 반환
        return Array.isArray(data) ? convertedDataArray : convertedDataArray[0];
    };      

    useEffect(() => {        
        getCodeList();

        const handleScroll = () => {
            if (graphicTrendContainerRef.current) {                
                setScrollLeft(graphicTrendContainerRef.current.scrollLeft);
            }
        };
        const ref = graphicTrendContainerRef.current;
        if (ref) {
            ref.addEventListener('scroll', handleScroll);
        }

        document.addEventListener("mousedown", handleClickOutside);
        return (ref) => {
            if (ref) {
                ref.removeEventListener('scroll', handleScroll);
            }
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);    

    useEffect(() => {
        if (isFromSearch) {
            getIsSearchNumericData()
        }else{
            getNumericData();    
        }
    }, [waveStartDate, trendZoom]);

    useEffect(() => {
        if(numericData.length === 0) { //원복
            if (!graphicTrendContainerRef.current) return;
            const parentRect = graphicTrendContainerRef.current.getBoundingClientRect();
            const height = numericParameters.length > 0 ? (parentRect.height) / numericParameters.length : 130;            
            setChartWidth(parentRect.width);
            setChartHeight(height);
            return;
        }        
        
        // console.log('numericData ',numericData);
        //const timeRanges = numericData.map(item => item.timestamp); //원복            
        //2025-10-20T10:18:58 기준으로 waveStartDate

        //여기서 endMoment는 포함하지 않았으면 좋겠음.
        const timeRanges = [];
        const startMoment = moment(waveStartDate);
        const endMoment = moment(waveEndDate);
        const interval = 30; // 30초 간격
        let currentMoment = startMoment.clone();
        while (currentMoment.isBefore(endMoment)) {
            timeRanges.push(currentMoment.format('YYYY-MM-DDTHH:mm:ss'));
            currentMoment.add(interval, 'seconds');
        }       
        //console.log('timeRanges ',timeRanges);

        setTimeRanges(timeRanges);               

        let height = 130;        

        if (graphicTrendContainerRef.current) {
            const parentRect = graphicTrendContainerRef.current.getBoundingClientRect();
            height = (parentRect.height - 39) / numericParameters.length;            
        }
                
        setChartWidth(170*timeRanges.length);
        setChartHeight(height);
    },[numericData])

    useEffect(() => {
        if (isTrendFull) {
            if (numericParameters.length < 2) {
                const additionalParameters = numericCodeList.filter(item => 
                    !numericParameters.some(param => param.value === item.value)
                ).slice(0, 2);                
    
                setNumericParameters(prev => [...prev, ...additionalParameters.map(item => ({
                    value: item.value,            
                    label: item.label
                }))]);
            }
        } else {
            if (numericParameters.length > 2) {
                setNumericParameters(prev => prev.slice(0, 1));
            }
        }
    }, [isTrendFull])

    useEffect(() => {              
        if(chartWidth === 0 ) return;       
        getPatientHistories(patientHistories);

    }, [chartWidth,selectBoxTimeInfo])

    useEffect(() => {
        if (!graphicTrendContainerRef.current || !timeRanges || timeRanges.length === 0 || !selectBoxTimeInfo) return;

        // selectBoxTimeInfo와 가장 가까운 timeRanges index 찾기
        const selectedIdx = timeRanges.findIndex(time => moment(time).isSame(moment(selectBoxTimeInfo)));
        if (selectedIdx === -1) return;

        // 한 칸의 너비 계산 (chartWidth / timeRanges.length)
        const cellWidth = chartWidth / timeRanges.length;

        // 현재 스크롤 위치에 해당하는 index 계산
        const currentScrollLeft = graphicTrendContainerRef.current.scrollLeft;
        const currentIdx = Math.round(currentScrollLeft / cellWidth);

        // 현재 스크롤 위치의 시간과 selectBoxTimeInfo의 시간 차이 계산 (초 단위)
        const currentTime = timeRanges[currentIdx];
        const diffSeconds = moment(selectBoxTimeInfo).diff(moment(currentTime), 'seconds');

        // 현재 시간(currentTime)이 selectBoxTimeInfo보다 앞이고, 300초 이내면 스크롤 이동하지 않음
        if (diffSeconds >= 0 && diffSeconds <= 300) return;

        // 스크롤 위치 계산 (맨 앞칸으로만 이동)
        const scrollLeft = Math.max(0, selectedIdx * cellWidth);

        graphicTrendContainerRef.current.scrollTo({
            left: scrollLeft,
        });
    }, [selectBoxTimeInfo, chartWidth, timeRanges]);

    return (
       <div className="relative h-full bg-[#2F2F2F]" style={{ width: 'calc(100% - 48px)' }}>
            <div className="flex justify-between items-center h-[40px] px-[20px]">
                <h2 className="text-white text-center font-medium text-lg leading-[110%] font-pretendard">
                    {t('trend.graphicTrend')} 
                </h2>
                {
                    isTrendFull && (
                        <div className="flex items-center justify-center cursor-pointer text-white rounded-[4px] border border-[#5E5E5E] bg-gradient-to-b from-[#5E5E5E] to-[#383838] p-[4px]" onClick={onClose}>
                            <IconArrowDown className="w-[18px] h-[18px] text-white" />
                        </div>
                    )
                }      
            </div>
            <div 
                ref={graphicTrendContainerRef}
                className={`${isTrendFull ? 'h-[370px]' : 'h-[146px]'} scrollbar-x scrollbar-x-10px relative overflow-y-hidden min-w-0`}                                 
            >
                <div
                    className="relative flex flex-col mx-[50px]"
                    style={{ 
                        width: chartWidth,                        
                    }}
                >
                    <div className="flex">
                        {
                            timeRanges && timeRanges.map((time,index) => {
                                return (
                                    <div key={index} className="flex-1 relative">
                                        <div className="absolute top-0 left-0 transform -translate-x-1/2 w-[1px] h-[8px] bg-[#5E5E5E]"></div>                                        
                                        <div className="text-[#DEDEDE] text-left font-pretendard text-[12px] font-light leading-[100%] border-t border-[#5E5E5E] pt-[11px] pb-[6px]">                                    
                                            <span className={`${moment(selectBoxTimeInfo).isSame(moment(time)) ? 'rounded-[4px] bg-black/90 px-[8px] py-[5px] left-[-30px]' : 'left-[-24px]'} relative  cursor-pointer`} onClick={() => handleSelectBoxTimeInfo(time)}>
                                                {moment(time).format('HH:mm:ss')}                                                
                                            </span>
                                        </div>
                                    </div>
                                )
                            })
                        }                        
                    </div>
                        {numericParameters &&
                            numericParameters.map((parameter, idx) => {
                                return (
                                    <div style={{height : chartHeight}} key={`numeric-area-${idx}`}>
                                        <div className="absolute my-[5px]" ref={el => dropdownRefs.current[idx] = el}  
                                            style={{
                                                zIndex: 10,
                                                left : 20 + scrollLeft
                                            }}
                                        >
                                            <div className="bg-gradient-to-b from-[#5E5E5E] to-[#383838] text-[#DEDEDE] w-[160px] h-[26px] py-[5px] px-[8px] rounded-[6px] cursor-pointer flex items-center justify-between border border-[#4E4E4E]" 
                                                onClick={
                                                    (e) => { e.stopPropagation(); setDropdownStates((prev) => ({
                                                        ...prev,
                                                        [`numeric${idx + 1}`]: !prev[`numeric${idx + 1}`]
                                                    }));  }}>
                                                <div className="w-[200px]">{parameter.label}</div>
                                            </div>
                                            {
                                                dropdownStates[`numeric${idx + 1}`] && (
                                                    <div className="absolute top-[30px] bg-[#1F1F1F] w-[160px] py-[8px] rounded-[6px] border border-[#5E5E5E] shadow-[0px_12px_12px_0px_rgba(0,0,0,0.4)] scrollbar scrollbar-h-small max-h-[70px] z-20">
                                                        {
                                                        // ✅ 다른 곳에서 사용 중인 code 필터링 (현재 선택된 것은 예외)
                                                        numericCodeList
                                                            .filter(code => {
                                                                // 현재 파라미터와 같으면 항상 표시
                                                                if (code.value === parameter.value) {
                                                                    return true;
                                                                }
                                                                
                                                                // 다른 드롭다운에서 사용 중인지 확인
                                                                const isUsedInOtherDropdown = numericParameters.some((param, paramIdx) => 
                                                                    paramIdx !== idx && param.value === code.value
                                                                );
                                                                
                                                                // 다른 곳에서 사용하지 않는 것만 표시
                                                                return !isUsedInOtherDropdown;
                                                            })
                                                            .map((code, codeIdx) => (
                                                                <div 
                                                                    className={`bg-[#1F1F1F] cursor-pointer h-[32px] flex items-center justify-between px-[8px] hover:bg-[#2F2F2F] ${parameter.value === code.value ? "text-[#3182F7]" : "text-white"}`} 
                                                                    onClick={(e) => { 
                                                                        e.stopPropagation();                                                                         
                                                                        handleChangeSelect(code, idx); 
                                                                        
                                                                        // 드롭다운 닫기 (값이 다를 때만)
                                                                        if (parameter.value !== code.value) {
                                                                            setDropdownStates((prev) => ({ 
                                                                                ...prev, 
                                                                                [`numeric${idx + 1}`]: false 
                                                                            }));
                                                                        }
                                                                    }}
                                                                    key={`numeric-${idx + 1}-code-${codeIdx}`}
                                                                >
                                                                    {code.label}
                                                                    {parameter.value === code.value && (
                                                                        <IconCheck className="w-4 h-4 ml-2" />
                                                                    )}
                                                                </div>
                                                            ))
                                                    }
                                                    </div>
                                                )
                                            }
                                            <div className="absolute transform -translate-y-1/2 pointer-events-none top-1/2 right-2">
                                                {dropdownStates[`numeric${idx + 1}`] ?  <IconArrowUp/> : <IconArrowDown/>}
                                            </div>
                                        </div>

                                        <div className="relative w-full h-full bg-transparent border-t border-[#4E4E4E]">                                            
                                            <GraphComponent 
                                                key={`graph-component-${idx}-${parameter.value}`}
                                                chartWidth={chartWidth}
                                                chartHeight={chartHeight}
                                                numericData={numericData}
                                                parameter={parameter.value}
                                                selectBoxTimeInfo={selectBoxTimeInfo}
                                                timeRanges={timeRanges}                                                
                                                UnitType={UnitType}
                                            />
                                        </div>
                                    </div>
                                )
                            })
                        }
                </div>    
                {/* 빗금 배경과 선 표시 */}
                {/* {stripedBackground && stripedBackground.length > 0 && 
                    stripedBackground.map((striped, idx) => (
                        <div 
                            key={`striped-area-${idx}`}
                            className="absolute top-[30px] h-[calc(100%-30px)] bg-black bg-opacity-20" 
                            style={{
                                zIndex: 1,
                                left: `${striped.start}px`, // 픽셀 단위로 변경
                                width: `${striped.end - striped.start}px`, // 픽셀 단위로 변경
                                background: 'repeating-linear-gradient(135deg, transparent, transparent 2px, #6C6C6C80 2px, #6C6C6C80 4px)' 
                            }}
                        />
                    ))
                } */}

                {stripedBackground && stripedBackground.length > 0 && 
                    stripedBackground.map((striped, idx) => (
                        <React.Fragment key={`striped-area-${idx}`}>
                            {/* 빗금 영역 */}
                            <div 
                                key={`striped-area-${idx}`}
                                className="absolute top-[30px] h-[calc(100%-30px)] bg-black bg-opacity-20" 
                                style={{
                                    zIndex: 1,
                                    left: `${striped.start}px`, // 픽셀 단위로 변경
                                    width: `${striped.end - striped.start}px`, // 픽셀 단위로 변경
                                    background: 'repeating-linear-gradient(135deg, transparent, transparent 2px, #6C6C6C80 2px, #6C6C6C80 4px)' 
                                }}
                            />

                            {/* 뒤쪽 빗금 시작점에 선 추가 */}
                            {   
                                striped.start > 50 && (
                                    <div 
                                        key={`patient-line-${idx}`}
                                        className="absolute top-[30px] w-[1px] h-[calc(100%-30px)] bg-white z-[2]"
                                        style={{ left: `${striped.start}px` }}
                                    >
                                        <div className="absolute top-0 left-[-10px] w-0 h-0 border-b-[10px] border-b-transparent border-r-[10px] border-r-white"></div>
                                        <div className="absolute bottom-0 left-[-10px] w-0 h-0 border-t-[10px] border-t-transparent border-r-[10px] border-r-white"></div>
                                    </div>
                                )
                            }
                        </React.Fragment>
                    ))
                }

                {/* 환자 라인들 별도로 표시 */}
                {Array.isArray(patientLines) && patientLines.map((linePos, lineIdx) => (
                    <div 
                        key={`patient-line-${lineIdx}`}
                        className="absolute top-[30px] w-[1px] h-[calc(100%-30px)] bg-white z-[2]"
                        style={{ left: `${linePos}px` }} // 픽셀 단위로 변경
                    >
                        <div className="absolute top-0 left-[-10px] w-0 h-0 border-b-[10px] border-b-transparent border-r-[10px] border-r-white"></div>
                        <div className="absolute bottom-0 left-[-10px] w-0 h-0 border-t-[10px] border-t-transparent border-r-[10px] border-r-white"></div>
                    </div>
                ))}
            </div> 
        </div> 
    );
};

export default GraphicTrend;
